import { Button, Grid, GridColumn } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import AnalyticsService from '../../services/AnalyticsService';
import { InvoicePaymentStore } from '../../stores/InvoicePaymentStore';
import { IMandatesStore } from '../../stores/MandatesStore';
import { IModalStore } from '../../stores/ModalStore';
import { IPosPaymentStore } from '../../stores/PosPaymentStore';
import { ISsoStore } from '../../stores/SsoStore';
import { ITranslateStore } from '../../stores/TranslateStore';
import { formatAsCurrency } from '../../util/FormatUtil';

import UnsettledReceivablesStore from '../../stores/UnsettledReceivablesStore';
import PrepaymentButton from './PrepaymentButton';

interface IUnpaidAmountWithButtonProps {
  translateStore?: ITranslateStore;
  mandatesStore?: IMandatesStore;
  modalStore?: IModalStore;
  analyticsService?: AnalyticsService;
  ssoStore?: ISsoStore;
  posPaymentStore?: IPosPaymentStore;
  invoicePaymentStore?: InvoicePaymentStore;
  unsettledReceivablesStore?: UnsettledReceivablesStore;
}

@inject('translateStore', 'mandatesStore', 'modalStore', 'analyticsService', 'ssoStore', 'posPaymentStore', 'invoicePaymentStore', 'unsettledReceivablesStore')
@observer
export default class UnpaidAmountWithButton extends React.Component<IUnpaidAmountWithButtonProps> {
  public componentDidMount(): void {
    this.props.mandatesStore.tryLoadMandate();
  }

  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;
    const unsettledReceivablesStore = this.props.unsettledReceivablesStore;

    return (
      <Grid className="text__margin-double" align={['end-sm', 'center-xs', 'middle-xs']}>
        <GridColumn width={['xs']}>
          <div className="text-bold">{translate('invoices.unpaid-invoices.amount-to-pay')}</div>
        </GridColumn>
        <GridColumn width={['xs']}>
          <div className="c-brand-primary-text text-bold h2">{formatAsCurrency(unsettledReceivablesStore.totalAmountToPay)}</div>
        </GridColumn>
        <GridColumn offset={['sm-1']} width={['xs']}>
          {unsettledReceivablesStore.totalAmountToPay > 0 ? this.payAllButton() : <PrepaymentButton style="normal" />}
        </GridColumn>
      </Grid>
    );
  }

  private payAllButton() {
    const translate = this.props.translateStore.translate;
    const mandate = this.props.mandatesStore.mandate;
    const analyticsService = this.props.analyticsService;

    if (mandate.isFinishedWithError) {
      throw new Error('Loading mandate failed');
    }

    if (mandate.isFinished && mandate.payload.billingMandateLevel === 'FULL') {
      return (
        <Button
          text={translate('invoices.unpaid-invoices.pay-all')}
          onClick={() => {
            this.props.invoicePaymentStore.payAll();
            analyticsService.unpaidInvoicesPayAll();
          }}
        />
      );
    }

    return <React.Fragment />;
  }
}
